import {ConditionalFieldDefinition} from "../conditionalRules/conditionalFieldDefinition";

export default class VisualizationFilterConditionalFields {
  static DATA_POINT_INCLUSION: ConditionalFieldDefinition = {
    fieldName: 'item_inclusion_condition',
    defaultConditionalValue: null,
    friendlyName: (r) => r.conditional_value,
  };

  static FILTER_FIELDS: ConditionalFieldDefinition[] = [
    VisualizationFilterConditionalFields.DATA_POINT_INCLUSION,
  ];
}